import { Action } from '@ngrx/store';

import { JobsPageFilter } from './filter.reducer';

export enum JobsPageFilterActionTypes {
  Set = '[JobsPageFilter] Set',
  SetAll = '[JobsPageFilter] Set all jobs',
  SetMy = '[JobsPageFilter] Set my jobs'
}

export class JobsPageFilterSet implements Action {
  readonly type = JobsPageFilterActionTypes.Set;

  constructor(public payload?: JobsPageFilter) {}
}

export class JobsPageFilterSetAll implements Action {
  readonly type = JobsPageFilterActionTypes.SetAll;
}

export class JobsPageFilterSetMy implements Action {
  readonly type = JobsPageFilterActionTypes.SetMy;
}

export type JobsPageFilterActionsUnion =
  | JobsPageFilterSet
  | JobsPageFilterSetAll
  | JobsPageFilterSetMy;
